var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("transition", { attrs: { name: "loading-transition" } }, [
            _c("div", { staticClass: "loading" }, [
              _c("div", { staticClass: "overlay-messages" }, [
                _c("div", { staticClass: "overlay-messages__description" }, [
                  _vm._v("\n          記事を読み込み中です\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "overlay-messages__icon overlay-messages__icon--bound"
                  },
                  [_c("span", { staticClass: "fi-download" })]
                )
              ])
            ])
          ])
        : _c("preview-vue", { on: { close: _vm.back } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }